import React, { FormEvent, useState } from 'react'

import * as S from './styles'
import { Button } from '../../components/button'
import { Input } from '../../components/input'
import {
  WhatsAppIcon,
  DarkLinkedInIcon,
  DarkInstagramIcon,
  DarkFacebookIcon,
  WhiteLinkedInIcon,
  WhiteInstagramIcon,
  WhiteFacebookIcon,
} from '@/assets/icons'
import { ButtonIcon, Text } from '@/components'
import { useInputValidation } from '@/hooks/useInputValidation'
import { Footer } from '@/service/api/footerHeader'
import { usePageContext } from '@/store/pageContext'
import { phoneMask } from '@/utils/masks'
import { validateEmail, validatePhone } from '@/utils/validations'

export type FooterProps = {
  footerData: Footer
}

export const FooterContainer: React.FC<FooterProps> = ({ footerData }) => {
  const { darkMode } = usePageContext()
  const [contactFormData, setContactFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
    phone: '',
  })
  const [newsletterFormData, setNewsletterFormData] = useState({
    email: '',
  })

  const [contactSubmitted, setContactSubmitted] = useState(false)
  const [newsletterSubmitted, setNewsletterSubmitted] = useState(false)

  const { handleBlur, handleTouched, handleErrorMessage, clearTouched } =
    useInputValidation()

  const handeleContactFormChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setContactFormData({
      ...contactFormData,
      [event.target.name]: event.target.name.includes('phone')
        ? phoneMask(event.target.value)
        : event.target.value,
    })
    handleTouched(event.target.id)
  }
  const handleNewsletterFormChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setNewsletterFormData({
      ...newsletterFormData,
      [event.target.name]: event.target.value,
    })
  }

  const handleContactSubmit = (e: FormEvent) => {
    e.preventDefault()
    setContactSubmitted(true)
    clearTouched()
  }

  const handleNewsletterSubmit = (e: FormEvent) => {
    e.preventDefault()
    setNewsletterSubmitted(true)
  }

  const handleSocialMediaClick = (url: string) => {
    window.open(url, '_blank')
  }

  return (
    <S.FooterContainer darkMode={darkMode}>
      <S.FormContainer>
        <div className="form-contact">
          <Text
            size="b1"
            className="newsletter-title"
            color={darkMode ? 'white' : 'darkgray'}
          >
            {footerData.forms.contactFormTitle}
          </Text>
          <form
            id="contact-form-site"
            name="Entre em contato - Site"
            onSubmit={handleContactSubmit}
          >
            <Input
              type="text"
              label={footerData.forms.nameField}
              name="name"
              placeholder={footerData.forms.namePlaceholder}
              onChange={handeleContactFormChange}
              onBlur={() => handleBlur('name')}
              value={contactFormData.name}
              width="47.5%"
              darkMode={darkMode}
              error={handleErrorMessage('name', contactFormData.name)}
            />
            <Input
              type="text"
              label={footerData.forms.companyField}
              name="company"
              placeholder={footerData.forms.companyPlaceholder}
              onChange={handeleContactFormChange}
              value={contactFormData.company}
              width="47.5%"
              darkMode={darkMode}
              onBlur={() => handleBlur('company')}
              error={handleErrorMessage('company', contactFormData.company)}
            />
            <Input
              type="email"
              label={footerData.forms.emailField}
              name="email"
              id="contactEmail"
              placeholder={footerData.forms.emailPlaceholder}
              onChange={handeleContactFormChange}
              value={contactFormData.email}
              width="47.5%"
              darkMode={darkMode}
              onBlur={() => handleBlur('email')}
              error={handleErrorMessage(
                'email',
                contactFormData.email,
                validateEmail,
                footerData.forms.emailErrorMessage,
              )}
            />
            <Input
              type="tel"
              label={footerData.forms.phoneField}
              name="phone"
              maxLength={19}
              placeholder={footerData.forms.phonePlaceholder}
              onChange={handeleContactFormChange}
              value={contactFormData.phone}
              width="47.5%"
              darkMode={darkMode}
              onBlur={() => handleBlur('phone')}
              error={handleErrorMessage(
                'phone',
                contactFormData.phone,
                validatePhone,
                footerData.forms.phoneErrorMessage,
              )}
            />
            <Input
              type="text"
              label={footerData.forms.intentField}
              name="message"
              placeholder={footerData.forms.intentPlaceholder}
              onChange={handeleContactFormChange}
              value={contactFormData.message}
              darkMode={darkMode}
              onBlur={() => handleBlur('message')}
              error={handleErrorMessage('message', contactFormData.message)}
            />
            <Button disabled={contactSubmitted}>
              {contactSubmitted
                ? 'Informações enviadas com sucesso'
                : footerData.forms.sendButton}
            </Button>
          </form>
        </div>
        <div className="form-newsletter">
          <Text
            size="b1"
            className="newsletter-title"
            color={darkMode ? 'white' : 'darkgray'}
          >
            {footerData.forms.newsletterFormTitle}
          </Text>
          <Text size="b3" color={darkMode ? 'white' : 'darkgray'}>
            {footerData.forms.newsletterFormDescription}
          </Text>
          <form
            id="newsletter-form-site"
            name="Assinantes Newsletter - Site"
            style={{ width: '100%' }}
            onSubmit={handleNewsletterSubmit}
          >
            <Input
              type="email"
              label={footerData.forms.emailField}
              name="email"
              id="newsletterEmail"
              placeholder={footerData.forms.emailPlaceholder}
              onChange={handleNewsletterFormChange}
              value={newsletterFormData.email}
              width="100%"
              darkMode={darkMode}
              onBlur={() => handleBlur('newletterEmail')}
              error={handleErrorMessage(
                'newletterEmail',
                newsletterFormData.email,
                validateEmail,
                footerData.forms.emailErrorMessage,
              )}
            />
            <Button disabled={newsletterSubmitted} type="submit">
              {newsletterSubmitted
                ? 'Informações enviadas com sucesso'
                : footerData.forms.subscribeButton}
            </Button>
          </form>
        </div>
      </S.FormContainer>
      <hr className="divider" />
      <S.ContactContainer>
        <div className="contact-physical">
          <div>
            <Text size="b1" color={darkMode ? 'white' : 'darkgray'}>
              {footerData.contact.phoneTitle}
            </Text>
            {footerData.contact.phones &&
              footerData.contact.phones.map((phone) => (
                <Text
                  size="b3"
                  key={phone}
                  color={darkMode ? 'white' : 'darkgray'}
                >
                  {phone}
                </Text>
              ))}
          </div>
          <div>
            <Text size="b1" color={darkMode ? 'white' : 'darkgray'}>
              {footerData.contact.addressTitle}
            </Text>
            <Text
              size="b3"
              color={darkMode ? 'white' : 'darkgray'}
            >{`${footerData.contact.address.street}, ${footerData.contact.address.number}, ${footerData.contact.address.complement}`}</Text>
            <Text
              size="b3"
              color={darkMode ? 'white' : 'darkgray'}
            >{`${footerData.contact.address.city} - ${footerData.contact.address.state} - ${footerData.contact.address.country}`}</Text>
          </div>
        </div>
        <div className="contact-social">
          <Text
            size="b1"
            color={darkMode ? 'white' : 'darkgray'}
          >{`${footerData.contact.email}`}</Text>
          <div className="contact-icons">
            <ButtonIcon
              className="wa-icon"
              icon={WhatsAppIcon}
              alt="Botão para abrir Whatsapp da Nata"
              onClick={() =>
                handleSocialMediaClick(footerData.contact.whatsAppUrl)
              }
            />
            <ButtonIcon
              className="ln-icon"
              icon={darkMode ? WhiteLinkedInIcon : DarkLinkedInIcon}
              alt="Botão para abrir Linkedin da Nata"
              onClick={() =>
                handleSocialMediaClick(footerData.contact.linkedinUrl)
              }
            />
            <ButtonIcon
              className="ig-icon"
              icon={darkMode ? WhiteInstagramIcon : DarkInstagramIcon}
              alt="Botão para abrir Instagram da Nata"
              onClick={() =>
                handleSocialMediaClick(footerData.contact.instagramUrl)
              }
            />
            <ButtonIcon
              className="fb-icon"
              icon={darkMode ? WhiteFacebookIcon : DarkFacebookIcon}
              alt="Botão para abrir Facebook da Nata"
              onClick={() =>
                handleSocialMediaClick(footerData.contact.facebookUrl)
              }
            />
          </div>
        </div>
      </S.ContactContainer>
    </S.FooterContainer>
  )
}
